import { findList } from "../../utils/functionUtils";
import { IRegisterOvertime } from "../models/registerOvertimeModes";
import { CODE_STATUS, LIST_LOAI_DON, LIST_STATUS, TYPE_DON } from "./managerRequestConsts";

export const INIT_REGISTER_OVERTIME: IRegisterOvertime = {
    employee: null,
    donViCongTacId: "",
    donViCongTacText: "",
    donViCongTac: null,
    phongBan: null,
    phongBanId: "",
    phongBanText: "",
    ngayNop: "",
    loaiDon: findList(LIST_LOAI_DON, TYPE_DON.DANG_KY_LAM_THEM, "type"),
    truongKhoa: null,
    trangThai: findList(LIST_STATUS, CODE_STATUS.TAO_MOI),
    ngayDuyet: null,
    ghiChu: "",
    employeeInfos: []
}

export const CODE_THOI_DIEM_LAM_THEM = {
    TRUOC_CA: 1,
    SAU_CA: 2,
    NGHI_GIUA_GIO: 3,
    NGAY_NGHI: 4,
}

export const LIST_THOI_DIEM_LAM_THEM = [
    { code: CODE_THOI_DIEM_LAM_THEM.TRUOC_CA, name: "Trước ca" },
    { code: CODE_THOI_DIEM_LAM_THEM.SAU_CA, name: "Sau ca" },
    { code: CODE_THOI_DIEM_LAM_THEM.NGHI_GIUA_GIO, name: "Nghỉ giữa giờ" },
    { code: CODE_THOI_DIEM_LAM_THEM.NGAY_NGHI, name: "Ngày nghỉ" }
]

export const KEY_TAB = {
    CHUA_GUI: "1",
    CHO_DUYET: "2",
    DA_DUYET: "3",
    TU_CHOI: "4"
};

export const DS_TAB_DANG_KI_LAM_THEM = [
    {
        eventKey: KEY_TAB.CHUA_GUI,
        title: "Chưa gửi",
    },
    {
        eventKey: KEY_TAB.CHO_DUYET,
        title: "Chờ duyệt",
    },
    {
        eventKey: KEY_TAB.DA_DUYET,
        title: "Đã duyệt",
    },
    {
        eventKey: KEY_TAB.TU_CHOI,
        title: "Từ chối",
    }
];

export const styleTemplateGiayBaoCaoLamThemGio = `
  @page {
    size: A4 portrait;
    margin: 15mm;
  }

  @media print {
    html, body {
      width: 210mm;
      height: 297mm;
      margin: 0;
      padding: 0;
      font-family: "Times New Roman", serif;
      color: #000;
    }

    #content-print {
      width: 180mm;
      margin-left: auto;
      margin-right: auto;
    }

    .word {
      width: 100%;
      page-break-inside: avoid;
    }

    table {
      border-collapse: collapse;
      width: 100%;
    }

    th, td {
      border: 1px solid #000 !important;
      padding: 4px 8px;
      font-size: 12pt;
    }

    .text-center {
      text-align: center;
    }

    .fw-600 {
      font-weight: 600;
    }

    .text-uppercase {
      text-transform: uppercase;
    }

    .ml-5 { margin-left: 5px; }
    .ml-80 { margin-left: 80px; }
    .mt-16 { margin-top: 16px; }
    .mb-00 { margin-bottom: 100px; }

    .flex {
      display: flex;
    }

    .flex-between {
      justify-content: space-between;
    }

    .text-left {
      text-align: left;
    }

    .flex-end {
      justify-content: flex-end;
    }

    .align-start {
      align-items: flex-start;
    }

    .max-w-300 {
      max-width: 300px;
    }

    .pl-10 {
      padding-left: 10px;
    }
  }
`;

export const styleTemplateDexuatLamThemGio = `
  @page {
    size: A4 portrait;
    margin: 15mm;
  }

  @media print {
    html, body {
      width: 210mm;
      height: 297mm;
      margin: 0;
      padding: 0;
      font-family: "Times New Roman", serif;
      color: #000;
    }

    #content-print {
      width: 180mm;
      margin-left: auto;
      margin-right: auto;
    }

    .word {
      width: 100%;
      page-break-inside: avoid;
    }

    .title-kinh-gui { margin-top: 15px; }

    table {
      border-collapse: collapse;
      width: 100%;
    }

    th, td {
      border: 1px solid #000 !important;
      padding: 4px 8px;
      font-size: 12pt;
    }

    .text-center {
      text-align: center;
    }

    .fw-600 {
      font-weight: 600;
    }

    .text-uppercase {
      text-transform: uppercase;
    }

    .ml-5 { margin-left: 5px; }
    .ml-260 { margin-left: 200px; }
    .mt-10 { margin-top: 10px; }
    .mt-16 { margin-top: 16px; }
    .mb-100 { margin-bottom: 100px; }
    .mr-5 { margin-right: 5px; }

    .flex {
      display: flex;
    }

    .flex-between {
      justify-content: space-between;
    }

    .text-left {
      text-align: left;
    }

    .flex-end {
      justify-content: flex-end;
    }

    .align-start {
      align-items: flex-start;
    }

    .max-w-300 {
      max-width: 300px;
    }

    .pl-10 {
      padding-left: 10px;
    }
    
    .fs-lg {
      font-size: 24px;
    }

    .text-capitalize-first {
      text-transform: capitalize;
    }

    .span-cong-viec {
      margin-top: 15px;
      margin-right: 3px;
    }
  }
`;